<template>
  <v-dialog v-model="mostrarBanner" max-width="800">
    <v-card class="banner-santander-card" @click="fecharBanner">
      <v-btn
        icon
        absolute
        top
        right
        small
        class="btn-close-banner"
        aria-label="Fechar"
        @click.stop="fecharBanner"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <img
        src="/upload/banner_boleto_santander.png"
        alt="A partir de 05 de novembro de 2026, os boletos de seguros Prestamista e Quebra de Garantia (SQG) passarão a ser emitidos pelo Banco Santander."
        class="banner-image"
      />
    </v-card>
  </v-dialog>
</template>

<script>
const CHAVE_SESSAO = 'bannerSantanderFechado';

export default {
  name: 'BannerSantander',
  data() {
    return {
      mostrarBanner: sessionStorage.getItem(CHAVE_SESSAO) !== 'true',
    };
  },
  watch: {
    mostrarBanner(valor) {
      if (!valor) {
        sessionStorage.setItem(CHAVE_SESSAO, 'true');
      }
    },
  },
  methods: {
    fecharBanner() {
      this.mostrarBanner = false;
    },
  },
};
</script>

<style scoped>
.banner-santander-card {
  overflow: hidden;
  cursor: pointer;
}

.banner-image {
  width: 100%;
  height: auto;
  display: block;
}

.btn-close-banner {
  z-index: 1;
  background-color: rgba(255, 255, 255, 0.9);
}

.btn-close-banner:hover {
  background-color: #fff;
}
</style>
